
export default {
    methods:{
        setTitle(){
            let f = (this.$store.getters.store.eshop.search+'').includes('elastic')?this.$store.getters.filters:this.$store.getters.sideFilters;
            //$store.getters.filters.business_activity
            let compound = (`${f.q || ''} ${f.category || f.subfamily || f.family || f.business_activity || ''} ${f.manufacturer || ''}  ${(f.persons||'').split("_or_").join(", ") || ''}`+'').split("_or_").join(" ")
            return compound|| '';
        }
    }
}
